import { Box, Grid, Skeleton, useMediaQuery } from "@mui/material";
import { bgColor, borderLineColor } from "configs/styles/muiThemes";
import React from "react";

function CatelogHeaderShimmer() {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return matches ? (
    <Box
      sx={{
        minHeight: "58px",
        display: "flex",
        alignItems: "center",
      }}
      borderBottom={"1px solid " + borderLineColor}
    >
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={{ md: 1.5, xs: 0.5 }}
      >
        <Grid item>
          <Skeleton
            variant="rectangle"
            width="80px"
            height={22}
            sx={{ borderRadius: "4px" }}
          />
        </Grid>
        <Grid item xs={9.15} display="flex" gap={2}>
          <Skeleton
            variant="rectangle"
            width="142px"
            height={30}
            sx={{ borderRadius: "4px" }}
          />
          <Skeleton
            variant="rectangle"
            width="142px"
            height={30}
            sx={{ borderRadius: "4px" }}
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <Box
      bgcolor={bgColor}
      sx={{
        minHeight: "46px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        px: "15px",
        gap: 1,
      }}
    >
      <Skeleton
        variant="rectangle"
        width="105px"
        height={30}
        sx={{ borderRadius: "50px" }}
      />
      <Skeleton
        variant="rectangle"
        width="100px"
        height={30}
        sx={{ borderRadius: "50px" }}
      />
      <Skeleton
        variant="rectangle"
        width="80px"
        height={30}
        sx={{ borderRadius: "50px" }}
      />
    </Box>
  );
}

export default CatelogHeaderShimmer;
